import type { IconData } from '@stacksjs/iconify-core'

export const ae4x3: IconData = {
  "body": "<path fill=\"#00732f\" d=\"M0 0h640v160H0z\"/><path fill=\"#fff\" d=\"M0 160h640v160H0z\"/><path fill=\"#000001\" d=\"M0 320h640v160H0z\"/><path fill=\"red\" d=\"M0 0h220v480H0z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ae4x3
